var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5",attrs:{"fluid":""}},[(_vm.state)?_c('live'):(!_vm.state)?_c('test'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }